const EXPIRY_TIME = (): Date => {
  const expireTime = new Date();
  expireTime.setSeconds(expireTime.getSeconds() + 120);
  return expireTime;
};
export { EXPIRY_TIME };
